import axiosInstance from "@/api/axiosInstance";
import { CompanyDetailResponse } from "@/modules/growthStages/features/Diagnostics/types/diagnostic";

/** Full diagnostic history for one company. */
export const fetchCompanyDiagnostics = async (
  companyId: number,
): Promise<CompanyDetailResponse> => {
  const response = await axiosInstance.get<CompanyDetailResponse>(
    `/api/private/diagnostics/companies/${companyId}`,
  );
  return response.data;
};
